import { render, staticRenderFns } from "./WizardContinueOrStart.vue?vue&type=template&id=5b15556a&scoped=true&"
import script from "./WizardContinueOrStart.vue?vue&type=script&lang=js&"
export * from "./WizardContinueOrStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15556a",
  null
  
)

export default component.exports